import React from "react";
import "./styles/PrivacyPolicy.css"; // Assurez-vous d'avoir un fichier CSS pour styliser votre composant

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy">
      <h1>Privacy Policy</h1>

      <section>
        <h2>1. Introduction</h2>
        <p>
          At WeeklyCyber, we respect your privacy and are committed to
          protecting your personal information. This Privacy Policy explains how
          we collect, use, and protect your data when you interact with our
          services, including subscribing to our newsletter, using our contact
          form, and making donations.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>We collect and process the following personal information:</p>
        <ul>
          <li>
            <strong>Email address:</strong> When you subscribe to our
            newsletter.
          </li>
          <li>
            <strong>Contact form data:</strong> Information provided voluntarily
            when you contact us through our contact form, including your email
            address, subject, and message content.
          </li>
          <li>
            <strong>Donation details:</strong> If you make a donation, we may
            collect optional information such as your name and email. However,
            providing your name is not mandatory.
          </li>
        </ul>
      </section>

      <section>
        <h2>3. Use of Information</h2>
        <p>
          The data collected is used exclusively for the following purposes:
        </p>
        <ul>
          <li>
            To send you our weekly newsletter with updates, tips, and other
            relevant content.
          </li>
          <li>To respond to inquiries submitted via the contact form.</li>
          <li>To manage and acknowledge donations when necessary.</li>
          <li>
            To improve our communication and services based on your feedback.
          </li>
        </ul>
      </section>

      <section>
        <h2>4. Donations and Data Privacy</h2>
        <p>
          Donations made on our platform are entirely voluntary. Donors may
          choose to remain anonymous by not providing their name. The
          information collected during the donation process is solely used for
          administrative purposes and will not be shared with third parties.
        </p>
      </section>

      <section>
        <h2>5. Data Processing and Third-Party Services</h2>
        <p>
          We use{" "}
          <a
            href="https://www.brevo.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Brevo
          </a>{" "}
          as our marketing platform. By submitting your email address for the
          newsletter subscription, you consent to the transfer and processing of
          your data by Brevo in accordance with their{" "}
          <a
            href="https://www.brevo.com/legal/privacypolicy/"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          .
        </p>
      </section>

      <section>
        <h2>6. Data Protection</h2>
        <p>
          We take appropriate technical and organizational measures to secure
          your personal data against unauthorized access, alteration,
          disclosure, or destruction. However, no online service can guarantee
          absolute security.
        </p>
      </section>

      <section>
        <h2>7. Data Sharing</h2>
        <p>
          We do not sell, rent, or share your personal data with third parties
          for marketing purposes. Data is shared only with trusted service
          providers, such as Brevo, solely for processing related to sending
          newsletters, managing donations, and handling contact form
          submissions.
        </p>
      </section>

      <section>
        <h2>8. Your Rights</h2>
        <p>
          As a user, you have the following rights regarding your personal data:
        </p>
        <ul>
          <li>Access your personal information and request a copy.</li>
          <li>Request corrections to inaccurate or incomplete information.</li>
          <li>
            Request the deletion of your personal data (“right to be
            forgotten”).
          </li>
          <li>
            Unsubscribe from the newsletter at any time by clicking the
            "unsubscribe" link included in each email.
          </li>
        </ul>
      </section>

      <section>
        <h2>9. Cookies</h2>
        <p>
          We use cookies and similar tracking technologies to enhance your
          browsing experience, improve our website performance, and analyze user
          interactions. These cookies may include:
        </p>
        <ul>
          <li>
            <strong>Essential cookies:</strong> Necessary for the proper
            functioning of the website.
          </li>
          <li>
            <strong>Analytical cookies:</strong> Used to analyze site traffic
            and user behavior (e.g., Google Analytics).
          </li>
          <li>
            <strong>Marketing cookies:</strong> Used for personalized
            advertising and retargeting (if applicable).
          </li>
        </ul>
        <p>
          <strong>Managing Cookies:</strong> Upon your first visit, you will
          have the option to accept or decline non-essential cookies via a
          consent banner. You can also change your preferences at any time
          through your browser settings.
        </p>
      </section>

      <section>
        <h2>10. Changes to This Privacy Policy</h2>
        <p>
          We reserve the right to update this Privacy Policy as needed to
          reflect changes in our practices or for other operational, legal, or
          regulatory reasons. Any changes will be posted on this page with an
          updated revision date.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>
          If you have any questions, concerns, or requests regarding this
          Privacy Policy, please contact us at{" "}
          <a href="mailto:support@weeklycyber.com">support@weeklycyber.com</a>.
        </p>
      </section>

      <section className="last-updated">
        <p>
          <strong> Last updated:</strong>Mars 17, 2025
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
